import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { AppShell } from '@/components/layout';
import { RouteErrorBoundary } from './ErrorBoundary';
import { ProtectedRoute } from './ProtectedRoute';
import { ROUTES } from './routes';

/**
 * Every screen is code-split, so the initial bundle carries only the shell
 * and the dashboard. This matters most on the mobile connections the app is
 * primarily used over.
 */
const DashboardPage = lazy(() => import('@/features/dashboard/DashboardPage'));
const TeamPage = lazy(() => import('@/features/team/TeamPage'));
const ContestsPage = lazy(() => import('@/features/contests/ContestsPage'));
const BuildTeamPage = lazy(() => import('@/features/contests/BuildTeamPage'));
const TransfersPage = lazy(() => import('@/features/transfers/TransfersPage'));
const FixturesPage = lazy(() => import('@/features/fixtures/FixturesPage'));
const MatchCentrePage = lazy(() => import('@/features/fixtures/MatchCentrePage'));
const LeaguesPage = lazy(() => import('@/features/leagues/LeaguesPage'));
const LeaderboardPage = lazy(() => import('@/features/leaderboard/LeaderboardPage'));
const ScoringPage = lazy(() => import('@/features/scoring/ScoringPage'));
const ProfilePage = lazy(() => import('@/features/profile/ProfilePage'));
const LoginPage = lazy(() => import('@/features/auth/LoginPage'));
const GoogleReturnPage = lazy(() => import('@/features/auth/GoogleReturnPage'));
const OnboardingPage = lazy(() => import('@/features/onboarding/OnboardingPage'));
const NotFoundPage = lazy(() => import('@/features/errors/NotFoundPage'));

export const router = createBrowserRouter([
  {
    errorElement: <RouteErrorBoundary />,
    children: [
      { path: ROUTES.login, element: <LoginPage /> },
      { path: ROUTES.authGoogle, element: <GoogleReturnPage /> },
      { path: ROUTES.onboarding, element: <OnboardingPage /> },
      {
        element: <ProtectedRoute />,
        children: [
          {
            element: <AppShell />,
            children: [
              { index: true, element: <DashboardPage /> },
              { path: ROUTES.team, element: <TeamPage /> },
              { path: '/team/:teamId', element: <TeamPage /> },
              { path: ROUTES.contests, element: <ContestsPage /> },
              { path: '/contests/:contestId/build', element: <BuildTeamPage /> },
              { path: ROUTES.transfers, element: <TransfersPage /> },
              { path: '/transfers/:teamId', element: <TransfersPage /> },
              { path: ROUTES.fixtures, element: <FixturesPage /> },
              { path: '/fixtures/:fixtureId', element: <MatchCentrePage /> },
              { path: ROUTES.leagues, element: <LeaguesPage /> },
              { path: ROUTES.leaderboard, element: <LeaderboardPage /> },
              { path: ROUTES.scoring, element: <ScoringPage /> },
              { path: ROUTES.profile, element: <ProfilePage /> },
            ],
          },
        ],
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
